<!-- START Dialog: Trial Started -->
<p-dialog
    header=""
    [(visible)]="showDialog"
    [style]="{ width: '40vw' }"
    [breakpoints]="{
        '1200px': '80vw',
        '800px': '100vw',
    }"
    [closable]="false"
    [closeOnEscape]="false"
    [modal]="true"
    (onHide)="onHide.emit()"
>
    <div
        class="text-center mb-16"
        style="
            background-image: url(&quot;../../../../assets/images/trial-start.png&quot;);
            height: 16vh;
            background-size: contain;
            background-repeat: no-repeat;
            background-position-x: center;
        "
    ></div>

    <ng-template pTemplate="content">
        <h1 class="mb-4 text-center">{{ "dialog_trialstarted_header" | translate }}</h1>
        <p class="mb-4 text-center">{{ "dialog_trialstarted_text" | translate }}<br /></p>

        <div class="flex justify-center">
            <ul class="feature-list mr-6">
                <li class="mb-6"><i class="feature-icon pi pi-check-circle"></i>{{ "dialog_trialstarted_bullet1" | translate }}</li>
                <li class="mb-6"><i class="feature-icon pi pi-check-circle"></i>{{ "dialog_trialstarted_bullet2" | translate }}</li>
                <li class="mb-6"><i class="feature-icon pi pi-check-circle"></i>{{ "dialog_trialstarted_bullet3" | translate }}</li>
            </ul>
            <ul class="feature-list">
                <li class="mb-6"><i class="feature-icon pi pi-check-circle"></i>{{ "dialog_trialstarted_bullet4" | translate }}</li>
                <li class="mb-6"><i class="feature-icon pi pi-check-circle"></i>{{ "dialog_trialstarted_bullet5" | translate }}</li>
                <li class="mb-6"><i class="feature-icon pi pi-check-circle"></i>{{ "dialog_trialstarted_bullet6" | translate }}</li>
            </ul>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="text-center">
            <p-button
                pRipple
                type="button"
                styleClass="p-button-lg"
                label="{{ 'dialog_trialstarted_button' | translate }}"
                (click)="openModalTryHardwareClicked.emit()"
            ></p-button>
        </div>
    </ng-template>
</p-dialog>
<!-- END Dialog: Start Trial -->
